import { Layout, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { get, put } from '../../Common/api'
import consumer from '../../Common/cable'
import EventPanel from './EventPanel'
import { useParams } from 'react-router'
import EventFilter from './EventFilter'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import EventDetail from './EventDetail'
import { useForm } from 'antd/es/form/Form'
import EventListXS from './EventListXS'
import EventListXL from './EventListXL'

export default function EventsPage () {
  const [events, setEvents] = useState([])
  const [event, setEvent] = useState({})
  const [pagination, setPagination] = useState({})
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState({})
  const { id } = useParams()
  const [form] = useForm()

  const screens = useBreakpoint()

  useEffect(() => {
    componentDidMount()
    if (id) { showEvent(id) }
  }, [])

  const updateEvents = (updatedEvent) => {
    if (updatedEvent?.id) {
      if (events.find((e) => e.id === updatedEvent.id)) {
        setEvents(events.map((e) => (e.id === updatedEvent.id) ? { ...e, ...updatedEvent } : e))
        if (selectedEvent.id === updatedEvent.id) {
          setSelectedEvent({ ...selectedEvent, ...updatedEvent })
        }
      } else {
        setEvents([{ ...updatedEvent, new: true }, ...events])
      }
    }
  }

  useEffect(() => {
    updateEvents(event)
  }, [event])

  const componentDidMount = () => {
    consumer.subscriptions.create({ channel: 'EventsChannel' }, {
      connected: () => { console.log('connected') },
      disconnected: () => { },
      received: (data) => { setEvent({ ...data.event, content: data.content_trix_html }) }
    })
  }

  const getEvents = async (eventFilter, pageNumber) => {
    setLoading(true)
    await get('admin/events', { ...eventFilter, page: pageNumber || 1 }, (res) => {
      setLoading(false)
      setEvents(res.events)
      setPagination(res.pagination)
    }, () => {
      setLoading(false)
    })
  }

  const updateEvent = async (event) => {
    setLoading(true)
    await put(`admin/events/${event.id}`, event, (newEvent) => {
      setSelectedEvent({ ...newEvent.event, content: newEvent.content_trix_html, comments: event.comments })
      setLoading(false)
    }, () => {
      setLoading(false)
    })
  }

  const getComments = async (id) => {
    setLoading(true)
    await get(`admin/events/${id}`, {}, (res) => {
      setLoading(false)
      setSelectedEvent({ ...res.event, comments: res.comments, content: res.event.content_trix_html })
    }, () => {
      setLoading(false)
    })
  }

  const showEvent = (id) => {
    getComments(id)
    setOpen(true)
  }

  const resolveEvent = async (event) => {
    setLoading(true)
    await put(`admin/events/${event.id}`, { ...event, resolved: !event.resolved }, (res) => {
      setLoading(false)
      event = { ...res.event, content: res.event.content_trix_html }
      setSelectedEvent(event)
      updateEvents(event)
    }, () => {
      setLoading(false)
    })
  }

  const onClose = () => {
    setSelectedEvent({})
    setOpen(false)
  }

  const addComment = (comments) => (comment) => {
    setSelectedEvent({
      ...selectedEvent,
      comment_count: selectedEvent.comment_count + 1,
      comments: [...comments, comment]
    })
  }

  return (
    <Layout>
      <Spin spinning={loading}>
        {!screens.xs &&
          <>
            <EventFilter setLoading={setLoading} getEvents={getEvents} form={form} />
            <EventListXL events={events} showEvent={showEvent} pagination={pagination} getEvents={getEvents} filters={form.getFieldsValue()} resolveEvent={resolveEvent} />
            <EventPanel event={selectedEvent} open={open} onClose={onClose} updateEvent={updateEvent} setSelectedEvent={setSelectedEvent} addComment={addComment} />
          </>
        }
        {screens.xs && !id && <EventListXS events={events} showEvent={showEvent} mobile={true} pagination={pagination} />}
        {screens.xs && id && <EventDetail event={selectedEvent} updateEvent={updateEvent} setSelectedEvent={setSelectedEvent} showEvent={() => showEvent(id)} addComment={addComment} />}
      </Spin>
    </Layout>
  )
}
